import { requestSystemSettingByKey } from '@/graphql/queries/admin';
import { getTemplates } from '@/modules/templates/services/templates.service';

export type AdminDashboardData = {
  templateCount: number;
  hasIntegrationKeys: boolean;
};

export async function getAdminDashboardData(): Promise<AdminDashboardData> {
  const [templatesResult, blocksKeySetting, openRouterKeySetting] = await Promise.all([
    getTemplates({ paging: { pageNo: 1, pageSize: 1 } }),
    requestSystemSettingByKey('blocksProjectKey'),
    requestSystemSettingByKey('openRouterApiKey'),
  ]);

  const templateCount = (templatesResult as any)?.totalCount ?? 0;

  const blocksKey = blocksKeySetting?.Value || import.meta.env.VITE_X_BLOCKS_KEY || '';
  const openRouterKey = openRouterKeySetting?.Value || '';

  return {
    templateCount,
    hasIntegrationKeys: Boolean(blocksKey && openRouterKey),
  };
}
